import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteRegion, getAllRegions, createRegion, editRegion } from '../../api/axiosRegions';
import { getAllZones } from '../../api/axiosZones';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';





const Regions = () => {
  const { zones, setZones,regions, setRegions, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedEditedZone, setSelectedEditedZone] = useState("");
  
  const [region, setRegion] = useState("");
  const [editedRegion, setEditedRegion] = useState("");
  


 

  const NewTitle = "All Regions";
  useEffect(() => {
    
    getAllRegions(setRegions, setFetcherror);
    getAllZones(setZones, setFetcherror);
    
  }, []);

  // Create New Array of Regions with Zones.
  const newregionsArray = regions.map((item) => {
    const result = zones.find((itemb) => itemb.id === item.zone_id);
    return { ...item, zone: result ? result.name : null };
  });
  

  const filteredRegions = newregionsArray.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()) || item.zone.toLowerCase().includes(globalFilter.toLowerCase()))
  const filteredReversedRegions = filteredRegions.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setRegions, setFetcherror, handleAllToasts) => {
    return () => {
      deleteRegion(pkid, setRegions, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Region?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedRegion(foundItem?.name);
    setSelectedEditedZone(zones.find((zone)=>zone.id === foundItem.zone_id));
  }



  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          <SearchToolBar
              setAddItemDialogVisible={setAddItemDialogVisible}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              searchPlaceholder="Regions"
              createLabel="Region"
          />
    
        
        <DataTable
          value={filteredRegions}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No regions found"
        >
                    <Column header="S/N" body={(rowData) => newregionsArray.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Zone" body={(rowData) => rowData.zone } sortable></Column>
                    <Column header="Region"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                          <TableActions
                            id={rowData.id}
                            data={regions}
                            getItemtoEdit={getItemtoEdit}
                            setSelectedId={setSelectedId}
                            setEditDialogVisible={setEditDialogVisible}
                            setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Region" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createRegion(region,selectedZone?.id, setRegion, setFetcherror, handleAllToasts, setRegions);
                if (region ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="regionzone" className="block text-900 font-medium mb-2">Zone </label>
                  <Dropdown
                   value={selectedZone} onChange={(e) => setSelectedZone(e.value)}
                   options={zones} optionLabel="name"
                  placeholder="-- Select Zone --" showClear className="w-full mb-4"
                  />
                

                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Region </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Region Name"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setRegion("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Region" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editRegion( selectedId, editedRegion, setEditedRegion, selectedEditedZone, setSelectedEditedZone, setFetcherror, handleAllToasts, setRegions);
                if (editedRegion) { setEditDialogVisible(false); }
                }}>
                  
                  <label htmlFor="regionzone" className="block text-900 font-medium mb-2">Zone </label>
                  <Dropdown
                   value={selectedEditedZone} onChange={(e) => setSelectedEditedZone(e.value)}
                   options={zones} optionLabel="name"
                  placeholder="-- Select Zone --" showClear className="w-full mb-4"
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Region Name"
                    value={editedRegion}
                    onChange={(e) => setEditedRegion(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setRegion("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setRegions, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Regions


